module.exports = __webpack_public_path__ + "static/media/tx.a2740b82.svg";